export default __webpack_public_path__ + "static/media/gmail.ab6acc4d.svg";